<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Namaz vaxtları {{ year }} -ci il</h1>

        <div class="row">
          <div class="col-md-3">
            <select v-model="city" @change="getCity">
              <option value="Absheron">Abşeron</option>
              <option value="Aghdam">Ağdam</option>
              <option value="Aghdash">Ağdaş</option>
              <option value="Aghjabadi">Ağcabədi</option>
              <option value="Aghstafa">Ağstafa</option>
              <option value="Aghsu">Ağsu</option>
              <option value="Astara">Astara</option>
              <option value="Babek">Babək</option>
              <option value="Baku">Bakı</option>
              <option value="Balakan">Balakən</option>
              <option value="Barda">Bərdə</option>
              <option value="Beylagan">Beyləqan</option>
              <option value="Bilasuvar">Biləsuvar</option>
              <option value="Dashkasan">Daşkəsən</option>
              <option value="Fuzuli">Füzuli</option>
              <option value="Gabala">Qəbələ</option>
              <option value="Gadabay">Gədəbəy</option>
              <option value="Gakh">Qax</option>
              <option value="Ganja">Gəncə</option>
              <option value="Gazakh">Qazax</option>
              <option value="Gobustan">Qobustan</option>
              <option value="Goranboy">Goranboy</option>
              <option value="Goychay">Göyçay</option>
              <option value="Goygol">Göygöl</option>
              <option value="Guba">Quba</option>
              <option value="Gubadly">Qubadlı</option>
              <option value="Gusar">Qusar</option>
              <option value="Hajigabul">Hacıqabulx</option>
              <option value="Imishli">İmişli</option>
              <option value="Ismailly">İsmayıllı</option>
              <option value="Jabrayil">Cəbrayıl</option>
              <option value="Jalilabad">Cəlilabad</option>
              <option value="Julfa">Culfa</option>
              <option value="Kalbajar">Kəlbəcər</option>
              <option value="Kangarli">Kəngərli</option>
              <option value="Khachmaz">Xaçmaz</option>
              <option value="Khankendi">Xankəndi</option>
              <option value="Khizi">Xızı</option>
              <option value="Khojaly">Xocalı</option>
              <option value="Khojavend">Xocavənd</option>
              <option value="Kurdamir">Kürdəmir</option>
              <option value="Lachin">Laçın</option>
              <option value="Lankaran">Lənkəran</option>
              <option value="Lerik">Lerik</option>
              <option value="Masally">Masallı</option>
              <option value="Mingachevir">Mingəçevir</option>
              <option value="Naftalan">Naftalan</option>
              <option value="Nakhchivan">Naxçıvan</option>
              <option value="Neftchala">Neftçala</option>
              <option value="Oghuz">Oğuz</option>
              <option value="Ordubad">Ordubad</option>
              <option value="Saatly">Saatlı</option>
              <option value="Sabirabad">Sabirabad</option>
              <option value="Sadarak">Sədərək</option>
              <option value="Salyan">Salyan</option>
              <option value="Samukh">Samux</option>
              <option value="Shabran">Şabran</option>
              <option value="Shahbuz">Şahbuz</option>
              <option value="Shaki">Şəki</option>
              <option value="Shamakhy">Şamaxı</option>
              <option value="Shamkir">Şəmkir</option>
              <option value="Sharur">Şərur</option>
              <option value="Shirvan">Şirvan</option>
              <option value="Shusha">Şuşa</option>
              <option value="Siyazan">Siyəzən</option>
              <option value="Sumqayit">Sumqayıt</option>
              <option value="Tartar">Tərtər</option>
              <option value="Tovuz">Tovuz</option>
              <option value="Ujar">Ucar</option>
              <option value="Yardimly">Yardımlı</option>
              <option value="Yevlakh">Yevlax</option>
              <option value="Zangilan">Zəngilan</option>
              <option value="Zaqatala">Zaqatala</option>
              <option value="Zardab">Zərdab</option>
            </select>
          </div>
          <div class="col-md-3">
            <select v-model="month" @change="getMonth">
              <option value="1">Yanvar</option>
              <option value="2">Fevral</option>
              <option value="3">Mart</option>
              <option value="4">Aprel</option>
              <option value="5">May</option>
              <option value="6">İyun</option>
              <option value="7">İyul</option>
              <option value="8">Avgust</option>
              <option value="9">Sentyabr</option>
              <option value="10">Oktyabr</option>
              <option value="11">Noyabr</option>
              <option value="12">Dekabr</option>
            </select>
          </div>
          <div class="col-md-3">
            <select v-model="method" @change="getMethod">
              <option value="1">University of Islamic Sciences, Karachi</option>
              <option value="2">Islamic Society of North America (ISNA)</option>
              <option value="3">Muslim World League</option>
              <option value="4">Umm Al-Qura University, Makkah</option>
              <option value="5">Egyptian General Authority of Survey</option>
            </select>
          </div>
        </div>

        <div class="spinner" v-if="loading"><div></div><div></div><div></div></div>

        <transition appear name="fade" mode="out-in" v-else>  
          <table>
            <caption>Aylıq təqvim</caption>
            <thead>
              <tr>
                <th>Tarix</th>
                <th>Fəcr</th>
                <th>Günəş</th>
                <th>Zöhr</th>
                <th>Əsr</th>
                <th>Məğrib</th>
                <th>İşa</th>
                <th>Gecəyarı</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(day, index) in prayerTimes" :class="{current: isCurrent(index)}">
                <td>{{ day.date.gregorian.date | parceDate }}</td>
                <td>{{ day.timings.Fajr | removeTimeZone }}</td>
                <td>{{ day.timings.Sunrise | removeTimeZone }}</td>
                <td>{{ day.timings.Dhuhr | removeTimeZone  }}</td>
                <td>{{ day.timings.Asr | removeTimeZone  }}</td>
                <td>{{ day.timings.Maghrib | removeTimeZone  }}</td>
                <td>{{ day.timings.Isha | removeTimeZone }}</td>
                <td>{{ day.timings.Midnight | removeTimeZone }}</td>
              </tr>
            </tbody>
          </table>
        </transition>

      </div>
    </div>
  </div>
</template>

<script> 
  import axios from 'axios'

  export default {
    data(){
      return {
        city: 'Baku',
        method: '3',
        year: '',
        month: '',
        day: '',
        url: '',
        prayerTimes: {},
        loading: false
      }
    },
    created(){
      this.today();
      this.createURL();
      this.getPrayerTime();
    },
    methods: {
      today: function(){
        let date = new Date();
        this.year = date.getFullYear();
        this.month = date.getMonth() + 1;
        this.day = date.getDate() - 1;
      },
      createURL: function(){
        this.url = "https://api.aladhan.com/v1/calendarByCity?city=" 
                    + this.city + "&country=Azerbaijan&timezonestring=Asia/Baku&method=" 
                    + this.method +"&month=" 
                    + this.month + "&year=" 
                    + this.year;
      },
      getPrayerTime: function(){
        this.loading = true;
        axios.get(this.url)
        .then(response => {
          this.loading = false;
          this.prayerTimes = response.data.data;
        })
        .catch(error => {
          this.loading = true;
        });
      },
      getMonth: function(){
        this.createURL();
        this.getPrayerTime();
      },
      getCity: function(){
        this.createURL();
        this.getPrayerTime();
      },
      getMethod: function(){
        this.createURL();
        this.getPrayerTime();
      },
      isCurrent: function(index){
        // выделяем сегодняшний день в таблице
        if(index === this.day){
          return true;
        } else {
          return false;
        }
      }
    },
    filters: {
      removeTimeZone: function(value) {
        return value.substring(0, 5);
      },
      parceDate: function(value) {
        let month = [ 'Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'İyun', 'İyul', 'Avgust', 'Sentyabr', 'Oktyabr', 'Noyabr', 'Dekabr' ];
        let arr = value.split('-');
        let str = Number(arr[0]) + ' ' + month[Number(arr[1] - 1)];
        return str;
      }
    }
    
  }
</script>

<style scoped>

select {
  margin-bottom: 0.5rem;
}

.current {
  background-color: #003366;
  color: #FFF;
  font-weight: bold;
}

</style>


// WEBPACK FOOTER //
// src/components/calc/Prayer.vue